<template>
  <div id="app">
    <router-view height=100% width=100%></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  methods:{
    isMobile(){
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        return true; // 移动端
      }else{
        return false; // PC端
      }
    }
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.push({ name:'m_ModelList'});
    } else {
      this.$router.replace({ name:'ModelList'});
      // this.$router.push({ name:'m_ModelList'});
    }
  }
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,body,#app {
	height:100%;
  
}
</style>